import { render, staticRenderFns } from "./PartnerUserBulkDeleteModal.vue?vue&type=template&id=9247215c&scoped=true"
import script from "./PartnerUserBulkDeleteModal.vue?vue&type=script&lang=ts"
export * from "./PartnerUserBulkDeleteModal.vue?vue&type=script&lang=ts"
import style0 from "./PartnerUserBulkDeleteModal.vue?vue&type=style&index=0&id=9247215c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9247215c",
  null
  
)

export default component.exports